<template>
    <div class="ui segments core_waybill"
        :class="{half: is_half_style}"
        >

        <HorizontalTop
            v-if="!is_vertical && (eventbus.change_current_template.value != 'waybill')"
            :core_waybill="core_waybill"
            :eventbus="eventbus"
            :statuses="statuses"
            :is_show_note="is_show_note"
            :active_button_to_detail_route_name="active_button_to_detail_route_name">
        </HorizontalTop>

        <HorizontalMain
            v-if="(!is_vertical) && (eventbus.change_current_template.value != 'min_card') && (eventbus.change_current_template.value != 'waybill')"
            :core_waybill="core_waybill"
            :is_can_update="is_can_update">
        </HorizontalMain>

        <VerticalTop
            v-if="is_vertical && (eventbus.change_current_template.value != 'waybill')"
            :core_waybill="core_waybill"
            :eventbus="eventbus"
            :statuses="statuses"
            :is_show_note="is_show_note"
            :active_button_to_detail_route_name="active_button_to_detail_route_name">
        </VerticalTop>

        <VerticalMain
            v-if="is_vertical && (eventbus.change_current_template.value != 'min_card') && (eventbus.change_current_template.value != 'waybill')"
            :is_in_scanner_modal="is_in_scanner_modal"
            :core_waybill="core_waybill">
        </VerticalMain>

        <WaybillLabel
            v-if="eventbus.change_current_template.value == 'waybill'"
            :core_waybill="core_waybill"
            :eventbus="eventbus"
            :is_auto_print="is_auto_print"
            :is_enable_auto_print_label="is_enable_auto_print_label">
        </WaybillLabel>

        <Buttons
            v-if="!is_processing && is_show_buttons"
            :core_waybill="core_waybill"
            :eventbus="eventbus"

            :active_button_color="active_button_color"
            :active_button_content="active_button_content"
            :active_button_channel="active_button_channel"

            :is_enable_auto_print_label="is_enable_auto_print_label"
            :is_show_change_template_btns="is_show_change_template_btns"
            :is_can_print_label="is_can_print_label"
            :is_can_update="is_can_update">
        </Buttons>

        <WaybillLabel
            v-if="is_can_print_label && (eventbus.change_current_template.value != 'waybill')"
            :core_waybill="core_waybill"
            :eventbus="eventbus"
            :is_auto_print="is_auto_print"
            :is_enable_auto_print_label="is_enable_auto_print_label">
        </WaybillLabel>

    </div>
</template>

<script>
import WaybillLabel from '@toolbox/core_waybill/card_partials/label.vue'
import Buttons from '@toolbox/core_waybill/card_partials/buttons.vue'
import VerticalTop from '@toolbox/core_waybill/card_partials/vertical_top.vue'
import VerticalMain from '@toolbox/core_waybill/card_partials/vertical_main.vue'
import HorizontalTop from '@toolbox/core_waybill/card_partials/horizontal_top.vue'
import HorizontalMain from '@toolbox/core_waybill/card_partials/horizontal_main.vue'
var CanUpdateField = require('@toolbox/core_waybill/.assets/javascripts/can_update_field.js')

export default {
    components: {
        WaybillLabel,
        Buttons,
        VerticalTop,
        VerticalMain,
        HorizontalTop,
        HorizontalMain,
    },
    props: {
        /*
         * Main
         */
        core_waybill: {
            default: {},
            type: Object
        },
        statuses: {
            default: () => { return [] },
            type: Array
        },
        scope: {
            default: 'provider',
            type: String
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },

        /*
         * 共用
         */
        is_auto_print: {
            default: false,
            type: Boolean
        },
        is_enable_auto_print_label: {
            default: false,
            type: Boolean
        },
        is_show_change_template_btns: {
            default: false,
            type: Boolean
        },
        is_can_print_label: {
            default: false,
            type: Boolean
        },
        is_can_update: {
            default: false,
            type: Boolean
        },
        is_in_scanner_modal: {
            default: false,
            type: Boolean
        },

        can_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        cant_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        focus_field_field_name: {
            default: "",
            type: String
        },

        /*
         * template options
         */
        is_half_style: {
            default: false,
            type: Boolean
        },
        is_vertical: {
            default: false,
            type: Boolean
        },
        is_show_note: {
            default: false,
            type: Boolean
        },

        /*
         * active button options
         */
        active_button_color: {
            default: "blue",
            type: String
        },
        active_button_content: {
            default: "更新",
            type: String
        },
        active_button_channel: {
            default: "",
            type: String
        },
        active_button_to_detail_route_name: {
            default: "",
            type: String
        },
    },
    data() {
        return {
            is_show_buttons: true,
            is_initialized: false,
            is_processing: true,
        }
    },
    computed: {
    },
    watch: {
        core_waybill() {
            this.init()
        },
        is_can_print_label() {
            this.init()
        },
        active_button_content() {
            this.init()
        },
        active_button_channel() {
            this.init()
        },
        is_can_update() {
            this.init()
        },
    },
    mounted() {
        if (this.core_waybill.number) {
            this.init()
        }
    },
    methods: {
        async init() {
            await this.set_is_show_buttons()
            await new Promise(resolve => {
                this.is_initialized = true
                this.is_processing = false
            })
        },
        set_is_show_buttons() {
            try {
                if (this.active_button_channel != "") {
                    throw "有按鈕特定channel"
                }
                if (this.is_can_update) {
                    throw "可更新"
                }
                if (this.is_can_print_label) {
                    throw "可列印"
                }
                this.is_show_buttons = false

            } catch (e) {
                this.is_show_buttons = true
            }

            return Promise.resolve()
        },
        /*
         * ========================================================================
         * $parent
         * ========================================================================
         */
        is_can_update_field(field_name = "") {
            return CanUpdateField(
                field_name,
                this.is_can_update,
                this.can_update_field_names,
                this.cant_update_field_names,
            );
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "../.assets/stylesheets/common_card.scss";

    .ui.segments.core_waybill {
        color: initial;
    }
</style>
